import { Link, useParams } from "react-router-dom";
import { useEvents } from "../hooks/useClubInfo";

export function EventDetail() {
  const { clubId, eventId } = useParams();
  const { events, loading } = useEvents(clubId);
  const event = events.find((e) => e.id === eventId);

  return (
    <main className="mx-auto min-h-dvh max-w-md px-5 pb-24 pt-6">
      <Link to={`/club/${clubId}/info?tab=events`} className="inline-flex items-center gap-1 text-sm font-medium text-turf-700">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-4 w-4">
          <path d="m15 6-6 6 6 6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        Zurück zu Events
      </Link>

      {loading && (
        <div className="mt-6 animate-fade-up flex items-center gap-4">
          <div className="skeleton h-16 w-16 rounded-2xl" />
          <div className="space-y-2">
            <div className="skeleton h-5 w-40 rounded" />
            <div className="skeleton h-4 w-24 rounded" />
          </div>
        </div>
      )}
      {!loading && !event && <p className="mt-6 text-ink-400">Event nicht gefunden.</p>}

      {event && (
        <article className="card animate-fade-up mt-5 rounded-2xl p-5">
          <div className="flex items-center gap-4">
            <div className="marker-badge h-16 w-16 flex-shrink-0 flex-col border-0 bg-turf-100 text-turf-700">
              <span className="text-xl font-bold leading-none">
                {new Date(event.date).toLocaleDateString("de-DE", { day: "2-digit" })}
              </span>
              <span className="text-xs uppercase leading-none">
                {new Date(event.date).toLocaleDateString("de-DE", { month: "short" })}
              </span>
            </div>
            <div>
              <h1 className="font-display text-xl font-semibold text-turf-900">{event.title}</h1>
              <p className="text-sm text-ink-600">
                {new Date(event.date).toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })} Uhr
              </p>
            </div>
          </div>

          <div className="mt-4 rule-scorecard" />
          <p className="mt-4 whitespace-pre-line text-base leading-relaxed text-ink-900">{event.description}</p>

          {event.registrationUrl && (
            <a
              href={event.registrationUrl}
              target="_blank"
              rel="noreferrer"
              className="mt-6 flex h-12 items-center justify-center rounded-xl bg-turf-700 font-semibold text-chalk-50 shadow-sm transition-transform active:scale-[0.985]"
            >
              Zur Anmeldung
            </a>
          )}
        </article>
      )}
    </main>
  );
}
